<template>
	<header class="site-header fixed left-0 right-0 top-0 z-10 w-full">
		<section class="main-menu">
			<div class="container">
				<div class="main-menu-wrapper flex flex-row items-center justify-center">
					<a href="/" class="site-header-logo">directori</a>
				</div>
			</div>
		</section>
	</header>
</template>
